var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.valueFormatted)?[_c('audio',{staticClass:"small-audio audio-control-charm",attrs:{"controls":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.params.valueFormatted,"type":"audio/mpeg"}}),_vm._v(" Your browser does not support the audio element. ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }